import { lazyLoadOnRender } from '@ms/yammer-libs-lazy';

const VivaEngageAppNotifications = () =>
  import(/* webpackChunkName: "4-feat-vivaengageappnotifications" */ './VivaEngageAppNotifications');
export default lazyLoadOnRender({ loader: VivaEngageAppNotifications });
